
import React from 'react';
import { formatCurrency } from '@/lib/utils';
import DataTable, { Column } from '@/components/ui/DataTable';
import { Service } from '@/lib/data';
import { useLanguage } from '@/hooks/useLanguage';

interface ServiceTableProps {
  services: Service[];
  isLoading?: boolean;
  className?: string;
}

const ServiceTable: React.FC<ServiceTableProps> = ({
  services,
  isLoading = false,
  className,
}) => {
  const { translate } = useLanguage();
  
  // Create a map of service IDs to service names for parent lookup
  const serviceMap = services.reduce((map, service) => {
    map[service.service_id] = service.service_name;
    return map;
  }, {} as Record<string, string>);

  const columns: Column<Service>[] = [
    {
      key: 'service_name',
      header: translate('services.serviceName'),
      cell: (service) => (
        <div className="font-medium">{service.service_name}</div>
      ),
      sortable: true,
    },
    {
      key: 'default_price',
      header: translate('services.defaultPrice'),
      cell: (service) => (
        <div className="font-mono text-right">
          {formatCurrency(service.default_price)}
        </div>
      ),
      sortable: true,
      className: 'text-right',
    },
    {
      key: 'parent_service_id',
      header: translate('services.parentService'),
      cell: (service) => (
        <div>
          {service.parent_service_id ? 
            <span>{serviceMap[service.parent_service_id] || '-'}</span> : 
            <span className="text-muted-foreground">-</span>
          }
        </div>
      ),
      sortable: true,
    },
  ];

  return (
    <div className="glass-card rounded-lg overflow-hidden">
      <DataTable
        data={services}
        columns={columns}
        keyField="service_id"
        isLoading={isLoading}
      />
    </div>
  );
};

export default ServiceTable;
